@let dimensions = asset().version_data | assetVersionDimensions;
<div
  class="list-assets-item"
  [class.dark-background]="darkBackground()"
  id="asset-{{ asset().id }}"
  [attr.data-transition-to-page]="pageTransitions()"
  [class.selected]="selected()"
  [class.not-dragging]="!draggingAny()"
  [class.dragging-item]="dragging()"
  [style.--cell-size]="cellSize() + 'px'"
  [style.--aspect-ratio]="dimensions.width + '/' + dimensions.height"
  appInferredHover="asset-{{ asset().id }}"
  (onInferredHoverChange)="isDesktop() && inferredHovering.set($event)"
  (mouseenter)="isDesktop() && hovering.set(true)"
  (mouseleave)="hovering.set(false)"
  (click)="assetClick.emit($event)"
  (mousemove)="assetMouseMove($event)"
>
  @if (inView()) {
    <div class="asset-container">
      @if ((hovering() || inferredHovering() || selected() || !isDesktop()) && allowSelect()) {
        <div class="selected-check" [@selectedCheck] (click)="assetSelect.emit($event); stopPropagation($event)">
          <app-svg src="/assets/icons/check.svg"></app-svg>
        </div>
      }

      <div class="asset" [class.vertical]="dimensions.height > dimensions.width" #assetEl>
        @if ((asset() | canDisplayAsset) && asset().type !== 'audio') {
          @let imgSrc =
            asset().version_data
              | assetVersionUrl
                : asset()
                : asset().version_data.status
                : cellSize()
                : cellSize()
                : gallery()?.watermark && asset().watermark_enabled;
          @if (asset().type === 'image' || asset().type === 'document') {
            <img [src]="imgSrc" [alt]="asset().name" id="{{ asset().id }}" [attr.data-picflow-hide]="true" />
          } @else {
            <img
              [src]="imgSrc"
              [alt]="asset().name"
              [class.hidden-asset]="isDesktop() && hovering()"
              id="{{ asset().id }}"
              [attr.data-picflow-hide]="true"
            />
            <div class="video-indicator">
              <app-svg src="/assets/icons/play.svg"></app-svg>
            </div>
            @if (hovering() && isDesktop()) {
              <div class="video-hover-line" [style.left]="hoverAssetOffsetX() * 100 + '%'"></div>
              <app-video-thumbnail
                [currentTime]="hoverAssetOffsetX() * asset().version_data.data['duration']"
                [asset]="asset()"
                [assetVersion]="asset().version_data"
                #thumbnail
              ></app-video-thumbnail>
              @if (thumbnail.loading()) {
                <div class="video-indicator loading">
                  <app-svg src="/assets/icons/play.svg"></app-svg>
                </div>
              }
            }
          }
        } @else if (asset().version_data.status === 'pending' || asset().version_data.status === 'in_progress') {
        } @else {
          <app-non-preview-file
            [asset]="asset()"
            [gallery]="gallery()"
            [showFilename]="showFilename()"
            [darkBackground]="darkBackground()"
            [showBackground]="true"
            [showBorder]="false"
          ></app-non-preview-file>
        }
      </div>

      @if ((gallery() && galleryPermissions()) || simpleMode()) {
        @if ((hovering() || inferredHovering()) && !simpleMode() && !selected()) {
          <app-asset-feedback
            [@assetFeedback]
            [asset]="asset()"
            [gallery]="gallery()"
            [galleryPermissions]="galleryPermissions()"
            [clientMode]="clientMode()"
            [is_liked]="asset().is_liked"
            [status]="asset().status"
            [color_label]="asset().color_label"
            [colorLabels]="colorLabels()"
            (toggleAssetLike)="toggleAssetLike.emit($event)"
            (updateAssetColorLabel)="updateAssetColorLabel.emit($event)"
            (updateAssetStatus)="updateAssetStatus.emit($event)"
          ></app-asset-feedback>
        } @else if (!selected()) {
          <app-asset-feedback-hints
            [@assetFeedbackHints]
            [asset]="asset()"
            [gallery]="gallery()"
            [galleryPermissions]="galleryPermissions()"
            [likes]="asset().likes"
            [is_liked]="asset().is_liked"
            [status]="asset().status"
            [color_label]="asset().color_label"
            [simpleMode]="simpleMode()"
            [darkBackground]="darkBackground()"
          ></app-asset-feedback-hints>
        }
      }
    </div>

    <div class="asset-name">
      <span>{{ asset().name }}</span>
    </div>

    @if (gallery() && galleryPermissions()) {
      @if ((hovering() || inferredHovering()) && !selected()) {
        @if (galleryPermissions().can_edit) {
          <app-context-menu
            class="asset-options"
            [options]="{ noSpacing: true, width: '240px' }"
            #assetBottomMenu
            contextHoverIdentifier="asset-{{ asset().id }}"
            [@assetOptions]
          >
            <button
              appButton
              name="asset-options"
              location="advanced-mode"
              color="grey-60a40"
              [iconButton]="true"
              height="0"
              shape="round"
              contextButton
              #button
            >
              <app-svg src="/assets/icons/dots-vertical.svg" size="0"></app-svg>
            </button>
            <div contextContent>
              @if (assetBottomMenu.isOpen()) {
                <app-asset-context-menu
                  [asset]="asset()"
                  [gallery]="gallery()"
                  [galleryPermissions]="galleryPermissions()"
                  (onClose)="assetBottomMenu.close()"
                  (onNewVersion)="onNewVersion.emit()"
                  (openShare)="openShareDialog()"
                >
                </app-asset-context-menu>
              }
            </div>
          </app-context-menu>
        } @else if (asset() | canDownloadAsset: gallery() : galleryPermissions()) {
          <app-asset-download-button
            class="asset-options"
            location="advanced-mode"
            [asset]="asset()"
            [gallery]="gallery()"
            [galleryPermissions]="galleryPermissions()"
            [@assetOptions]
          >
            <button
              appButton
              name="download"
              location="advanced-mode"
              color="grey-60a40"
              [iconButton]="true"
              height="0"
              shape="round"
            >
              <app-svg src="/assets/icons/download.svg" size="0"></app-svg>
            </button>
          </app-asset-download-button>
        }
      }
    }
  }
</div>
